// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SimplePaperPodcast-cls1__fa591e22b7ff6087e363{/*!*/}.SimplePaperPodcast-cls2___b21da433e5bd4a0492d{min-height:40px;display:flex;align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SimplePaperPodcast-cls1__fa591e22b7ff6087e363",
	"cls2": "SimplePaperPodcast-cls2___b21da433e5bd4a0492d SimplePaperPodcast-cls1__fa591e22b7ff6087e363"
};
export default ___CSS_LOADER_EXPORT___;
